import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { Component, ViewContainerRef } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import { BiUrls } from '../../biUrls';

@Component({
    selector: 'uom',
    templateUrl: 'uom.component.html'
})

export class UomComponent {

    public uomReg: string = '';
    public sPage: number = 0;
    public lastRegex: string = '';

    public uomData: any = { id: null, name: '', uomCode: null, uomDesc: '', deleted: 0 };
    public mainPage: boolean = true;
    public uomPage: boolean = false;
    public uomList: any = [];
    public saveButton: boolean = false;
    public accessDenied: boolean = false;
    public onStart: boolean = false;
    public isEdit: boolean = false;
    public pageNo: number = 0;
    public pageSize: number = 10;
    public startingPage: number = 0;
    public currentPage: number = 1;
    public selectedUomId: number;
    public endingPage: number;
    public totalUom: number = 0;
    public totalPages: number = 0;
    public loader: boolean = false;

    constructor(
        public uomService: MDMService,
        public toastr: ToasterComponent,
        public vcr: ViewContainerRef) {
        this.toastr.setViewRef(vcr);
    }

    ngOnInit() {
        if (this.uomService.isBIAdmin) {
            this.loadUom();
        } else {
            this.accessDenied = true;
        }
    }

    public entityOps(event) {
        if (this.selectedUomId == null) {
            this.selectedUomId = event.target.id;
        } else {
            this.selectedUomId = null;
        }
    }

    public closeDropDown(event) {
        this.selectedUomId = null;
    }

    public onPageChange(event: number): void {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.uomReg != '') {
            this.searchPUom();
        } else {
            this.loadUom();
        }
        this.setEndingPage(this.totalUom);
    }

    public setEndingPage(total) {
        let self = this;
        if (self.currentPage == 1) {
            this.startingPage = 0;
            if (total > this.pageSize) {
                this.endingPage = this.pageSize;
            } else {
                this.endingPage = total;
            }
        } else {
            this.startingPage = 0 + ((self.currentPage - 1) * +this.pageSize);
            this.endingPage = +this.pageSize + ((self.currentPage - 1) * +this.pageSize);
            if (this.endingPage > total) {
                this.endingPage = total;
            }
        }
    }

    // For Pagination
    public OnPageSizeChanged(event) {
        this.pageSize = event.target.value;
        let maxPage = Math.floor(this.totalUom / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadUom();
    }

    public loadUom() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            self.mainPage = true;
            this.uomService.getDataByPage(BiUrls.UOM, self.pageNo, self.pageSize).then((res) => {
                self.uomList = [];
                self.totalPages = 0;
                self.totalUom = 0;
                if (res != undefined) {
                    self.uomList = res.data != undefined &&
                        res.data.pageElements != undefined ? res.data.pageElements :
                        self.toastr.showError('No results found');
                    self.totalUom = res.data != undefined &&
                        res.data.total != undefined ? res.data.total : 0;
                    self.setEndingPage(self.totalUom);
                    resolve('completed');
                }
                self.loader = false;
            }, (error) => {
                console.error(error);
            });
        });
    }

    public addNewUom() {
        this.mainPage = false;
        this.uomPage = true;
        this.uomData = { id: null, name: '', uomDesc: '', deleted: 0 };
    }

    // By Lalu
    public searchPUom() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            self.mainPage = true;
            self.uomList = [];
            if (self.uomReg != self.lastRegex) {
                self.sPage = 0;
            } else {
                self.sPage = self.currentPage - 1;
                self.currentPage = 1;
            }
            self.lastRegex = self.uomReg;
            self.uomService.search(BiUrls.UOM, BiUrls.SEARCH_P_UOM,
                self.uomReg, self.sPage, self.pageSize).then((res) => {
                    self.loadSearchedPUom(res);
                    self.loader = false;
                }, (error) => {
                    console.error(error);
                });
            resolve('completed');
        })
    }

    // By Lalu
    public loadSearchedPUom(res) {
        let self = this;
        self.uomList = (res != undefined) ? res.data.pageElements : [];
        self.totalUom = (res != undefined) ? res.data.total : 0;
        self.setEndingPage(self.totalUom);
    }

    public onSave() {
        let validate: any = this.validater();
        if (validate != '') {
            this.toastr.showError(validate);
        } else {
            let self = this;
            self.loader = true;
            self.saveButton = true;
            if (self.isEdit) {
                console.log('ON EDIT');
                self.uomService.update(BiUrls.UOM, self.uomData).then((res) => {
                    self.loadAfterSaveOrEdit(res, 'edit');
                });
            } else {
                console.log('ON SAVE');
                self.uomService.save(BiUrls.UOM, self.uomData).then((res) => {
                    self.loadAfterSaveOrEdit(res, 'new');
                });
            }
        }
    }

    public loadAfterSaveOrEdit(result, type) {
        let self = this;
        self.totalPages = Math.floor(self.totalUom / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo :
            self.totalPages;
        let text = type == 'new' ? 'UOM saved successfully' : 'Changes saved successfully';
        if (result.error == undefined && result.success == true) {
            self.toastr.showSuccess(text);
            try {
                if (self.uomReg != '') {
                    self.searchPUom().then((res) => {
                        self.setPageFieldsAfterLoading();
                    });
                } else {
                    self.loadUom().then((res) => {
                        self.setPageFieldsAfterLoading();
                    });
                }
            } catch (e) {
                console.log(e);
                self.setPageFieldsAfterLoading();
            }
        } else {
            self.toastr.showError(result.errorMessage ? result.errorMessage : 'Failed to save UOM');
            self.saveButton = false;
            self.loader = false;
        }
        self.currentPage = self.pageNo + 1;
    }

    public setPageFieldsAfterLoading() {

        let self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.uomPage = false;
        self.isEdit = false;
        self.loader = false;
    }

    public clickEdit(uom) {
        console.log('On Edit Controller ...');
        let self = this;
        self.loader = true;
        self.selectedUomId = null;
        self.uomService.getDataById(BiUrls.UOM, uom.id).then((res) => {
            if (res == undefined || res.data == undefined) {
                self.toastr.showError('Cannot load the UOM');
                self.loadUom();
            } else {
                uom = res.data;
                self.isEdit = true;
                self.loader = false;
                self.mainPage = false;
                self.uomPage = true;
                self.uomData = JSON.parse(JSON.stringify(uom));
            }
            self.loader = false;
        }, (error) => {
            console.error(error);
        });
    }

    public onBack() {
        this.mainPage = true;
        this.uomPage = false;
        this.selectedUomId = null;
        this.uomData = {};
        this.isEdit = false;
    }

    public delete(uom) {
        let self = this;
        self.uomService.delete(BiUrls.UOM, uom.id).then((response) => {
            self.loader = false;
            self.pageNo = self.uomList.length == 1 ?
                self.totalUom == 1 ? 0 : --self.pageNo : self.pageNo;
            self.loadUom();
            if (response == undefined || response.data == undefined) {
                self.toastr.showError('Unable to remove UOM');
            } else {
                self.toastr.showSuccess(uom.name + ' removed successfully');
            }
        }, (error) => {
            console.error(error);
        });
    }

    public removeUom(uom) {
        let r = confirm('Are you sure you want to remove the UOM ' + uom.name + ' ?');
        if (r == true) {
            this.delete(uom);
        }
    }

    public validater() {
        if (this.uomData.name == undefined || this.uomData.name.trim() == '') {
            return 'Please enter the name for UOM';
        } else {
            this.uomData.name = this.uomData.name.trim();
            this.uomData.uomDesc = this.uomData.uomDesc != undefined ?
                this.uomData.uomDesc.trim() : null;
            return '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/uom.component.ts